/* istanbul ignore file */

import { SiteData } from '../interfaces/site-data';
import { GeoJsonFeature } from './geo-json-feature-model';
import { SiteColumnSettings } from './site-column-settings';

export class Site {
    active = false;
    activeIsLoading?: boolean;
    address = "";
    associated?: boolean;
    associationIsLoading?: boolean;
    chargeNumber: string | undefined = "";
    checked?: boolean;
    city = "";
    clientRequested?: boolean;
    cost?: string;
    columnSettings: SiteColumnSettings[];
    createdBy = "";
    pinColor?: string;
    pinId?: number;
    data?: SiteData;
    dateCreated?: string;
    dropdownName?: string;
    id = "";
    isChargeNumberValid?: boolean;
    isNewRecord?: boolean;
    isSaving?: boolean;
    latitude: number;
    longitude: number;
    geoJson?: GeoJsonFeature | undefined;
    geoJsonFileName?: string | undefined;
    siteType?: number;
    projects?: string[];
    projId?: string;
    renewalProcessedOn?: string;
    renewCountDown?: number;
    renewDate?: string;
    subscriptionStartDate?: string;
    dateSubscribed?: string;
    renewSiteSubscription?: boolean;
    requestDetails?: object;
    saving?: boolean;
    showSite = true;
    showSiteIsLoading?: boolean;
    siteName = "";
    siteNo = "";
    state = "";
    type = "";
    zipCode = "";
    isAutoRenewEnabled?: boolean;
}
